import { render, staticRenderFns } from "./pjnoticeInfo.vue?vue&type=template&id=4f4ab36f&scoped=true"
import script from "./pjnoticeInfo.vue?vue&type=script&lang=js"
export * from "./pjnoticeInfo.vue?vue&type=script&lang=js"
import style0 from "./pjnoticeInfo.vue?vue&type=style&index=0&id=4f4ab36f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4ab36f",
  null
  
)

export default component.exports